






































































































import { ValidationObserver } from 'vee-validate';

import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { isObject } from 'lodash';
import { getConfig } from '@/web/utils/configuration';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default {
  props: {
    onSignupFn: null,
    loginName: {
      type: String,
      default: 'studio-login',
    },
    displayLoginLink: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ValidationObserver,
  },
  data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      formError: null,
      inProgress: false,
      agreeTerms: false,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
    config() {
      return getConfig();
    },
    styles() {
      const photoSrc =
        this.studio?.cover_photo?.storage_url ??
        this.studio?.cover_photo?.embedded_image_url;
      if (photoSrc) {
        return {
          backgroundImage: `url(${photoSrc})`,
        };
      } else return {};
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  methods: {
    async signUp() {
      this.inProgress = true;

      const reCaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
      const reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
        action: 'studentsignup',
      });

      const data = {
        agree_terms: this.agreeTerms,
        email: this.email,
        password: this.password,
        password1: this.password,
        studio_url: this.studio.studio_url,
        first_name: this.firstName,
        last_name: this.lastName,
        token: reCaptchaToken,
      };

      const userData = {
        student: {
          first_name: this.firstName,
          last_name: this.lastName,
        },
      };

      try {
        const loginResponse = await this.$store.dispatch('user/register', data);
        await this.$store.dispatch('user/updateStudent', userData);
        this.onLogin(loginResponse);
      } catch (error) {
        const errorMessage = errorToMessage(error.response);
        if (typeof error === 'string') {
          this.formError = errorMessage;
        } else {
          this.formError = null;
          this.$refs.form.setErrors(errorMessage);
        }

        if (isObject(errorMessage)) {
          this.formError = null;
          this.$refs.form.setErrors(errorMessage);
        } else if (errorMessage) {
          this.formError = errorMessage;
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: error,
            duration: -1, // stay ON
          });
        }
      } finally {
        this.inProgress = false;
      }
    },
    async onLogin(loginResponse: LoginResponse) {
      await this.$store.dispatch('studio/joinStudio', this.studioURL);
      if (this.onSignupFn) {
        this.$emit('close');
        this.onSignupFn();
      } else {
        const { user_type } = loginResponse;
        const redirectUrl = this.$route.query.redirect;

        if (redirectUrl) {
          this.$router.replace(redirectUrl);
        } else {
          const name = user_type === 'student' ? 'studio-home' : 'dashboard';
          this.$router.replace({ name });
        }
      }
    },
    socialLoginError(error) {
      let errorMessage;
      switch (error.code) {
        case 'auth/account-exists-with-different-credential':
          errorMessage = this.$t('LOGIN.TEXT.WE_VE_GOT_AN_ACCOUNT_WITH_THIS');
          break;
        default:
          errorMessage = errorToMessage(error.response);
          break;
      }

      this.$notify({
        group: 'app',
        type: 'error',
        text: errorMessage,
      });
    },
    async facebookLogin() {
      try {
        const provider = new this.$firebase.auth.FacebookAuthProvider();
        const result = await this.$firebase.auth().signInWithPopup(provider);
        const loginResponse = await this.$store.dispatch(
          'user/loginWithFacebook',
          result.credential.accessToken
        );
        this.onLogin(loginResponse);
      } catch (error) {
        this.socialLoginError(error);
      }
    },
    async googleLogin() {
      try {
        const provider = new this.$firebase.auth.GoogleAuthProvider();
        const result = await this.$firebase.auth().signInWithPopup(provider);
        const loginResponse = await this.$store.dispatch(
          'user/loginWithGoogle',
          result.credential.accessToken
        );
        this.onLogin(loginResponse);
      } catch (error) {
        this.socialLoginError(error);
      }
    },
    async appleLogin() {
      try {
        const provider = new this.$firebase.auth.OAuthProvider('apple.com');
        provider.addScope('email');
        provider.addScope('name');
        const result = await this.$firebase.auth().signInWithPopup(provider);
        const loginResponse = await this.$store.dispatch(
          'user/loginWithApple',
          result.credential.accessToken
        );
        this.onLogin(loginResponse);
      } catch (error) {
        this.socialLoginError(error);
      }
    },
  },
};
